import { render, staticRenderFns } from "./MainInsuranceDataForm.vue?vue&type=template&id=3b88fd26&"
import script from "./MainInsuranceDataForm.vue?vue&type=script&lang=js&"
export * from "./MainInsuranceDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports